/**
 * True when running on macOS/iOS, where the primary modifier key is ⌘ (Cmd)
 * rather than Ctrl. Prefers the modern User-Agent Client Hints API and falls
 * back to the (deprecated but universally available) `navigator.platform`,
 * then the user-agent string.
 */
export const isApplePlatform = (): boolean => {
    if (typeof navigator === 'undefined') return false;

    const uaPlatform = (navigator as Navigator & { userAgentData?: { platform?: string } })
        .userAgentData?.platform;
    if (uaPlatform) return /mac|ios|iphone|ipad/i.test(uaPlatform);

    if (navigator.platform) return /mac|iphone|ipad|ipod/i.test(navigator.platform);

    return /mac|iphone|ipad|ipod/i.test(navigator.userAgent);
};

/** The primary modifier on its own, for shortcuts drawn as separate keycaps. */
export const primaryModifierKey = (): string => (isApplePlatform() ? '⌘' : 'Ctrl');

/**
 * Formats a primary-modifier shortcut for display: "⌘C" on Apple (no
 * separator, matching macOS convention), "Ctrl+C" elsewhere.
 */
export const primaryModifierCombo = (key: string): string =>
    isApplePlatform() ? `${primaryModifierKey()}${key}` : `${primaryModifierKey()}+${key}`;
